import styled from '@emotion/styled';
import Chip, { ChipProps } from '@portalterreno/react-ui-core/Chip';

export type CyberChipProps = ChipProps;

const StyledCyberChip = styled(Chip)(
  {
    'borderRadius': 15,
    'marginRight': 9,
    'border': 'none',
    'fontWeight': 400,
    '&:hover': {
      color: 'inherit'
    }
  },
  ({ theme }) => ({
    'fontSize': theme.typography.fontSize.small,
    'backgroundColor': theme.palette.colors.orangeRed,
    'color': theme.palette.colors.white,
    '&:hover': {
      backgroundColor: theme.palette.colors.orangeRed,
      color: theme.palette.colors.white
    }
  })
);

export default StyledCyberChip;
